import { FC, ReactNode, useCallback, useEffect, useRef, useState } from "react";
import cl from "classnames";
import styles from "./CatalogFilter.module.scss";
import { useObserver } from "@/lib/hooks/useObserver";
import { useAppSelector } from "@/lib/store/app";
import { useCatalogActions } from "@/lib/store/slices/catalog";
import { P2 } from "../../../../components/Typography";
import { useTranslation } from "next-i18next";

import { useCatalogFilter } from "@/lib/hooks/useCatalogFilter";
import useEmblaCarousel from "embla-carousel-react";
import { useDebounce } from "@/lib/hooks/useDebounce";
import { IFirstRowItem } from "../../../../../types/catalogPage";
import { CircleButton } from "@/lib/ui/components/Buttons";
import { ArrowIcon } from "@/lib/ui/icons";
import { CatalogFilterDropdownRow } from "./CatalogFilterDropdownRow";
import { firstRowIcons } from "./constants";
import { Chips } from "../../../../components/Chips";
import { CatalogChipsRow } from "../CatalogChipsRow";

export const CatalogFilter: FC<{
  secondRowContentMobile?: ReactNode;
  firstRowItems: IFirstRowItem[];
}> = ({ secondRowContentMobile, firstRowItems }) => {
  const { t } = useTranslation("index");
  const filterRef = useRef<HTMLDivElement>(null);
  const isFixed = useAppSelector((state) => state.catalog.isFixedFilter);
  const { setFixedFilter } = useCatalogActions();

  useObserver({
    ref: filterRef,
    isInterTrue: () => setFixedFilter(false),
    isInterFalse: () => setFixedFilter(true),
  });

  useEffect(() => {
    return () => {
      if (!isFixed) {
        setFixedFilter(false);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setFixedFilter]);

  return (
    <div className={styles.filter}>
      <div className={styles.filter__ref} ref={filterRef} />

      <div
        className={cl(styles.filter__second, isFixed && styles["filter__second--fixed"])}
      >
        <div
          className={cl(styles["filter__second--mobile"], isFixed && styles.container)}
        >
          {isFixed ? secondRowContentMobile : null}

          <CatalogChipsRow firstRowItems={firstRowItems} />
        </div>
        <div
          className={cl(styles["filter__second--desktop"], isFixed && styles.container)}
        >
          <CatalogFilterDropdownRow isFixed={!!isFixed} />
          <CatalogChipsRow firstRowItems={firstRowItems} />
        </div>
      </div>
    </div>
  );
};
